
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/how-to/mint-erc-1155",
      function () {
        return require("private-next-pages/docs/how-to/mint-erc-1155.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/how-to/mint-erc-1155"])
      });
    }
  